import { render, staticRenderFns } from "./vcHeaderCrud.vue?vue&type=template&id=72ac82f8&scoped=true&"
import script from "./vcHeaderCrud.vue?vue&type=script&lang=js&"
export * from "./vcHeaderCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac82f8",
  null
  
)

export default component.exports